"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processTrace = void 0;
const tslib_1 = require("tslib");
const path = tslib_1.__importStar(require("path"));
const source_map_1 = require("source-map");
const utils_1 = require("./utils");
exports.processTrace = async ({ trace, sourceMaps, onlyFileName, }) => {
    if (sourceMaps === undefined) {
        return trace.map(() => undefined);
    }
    async function withSourceMaps(consumers, remainingSourceMaps) {
        if (remainingSourceMaps.length === 0) {
            const mutableTraceLines = [];
            for (const { line: lineNumber, address } of trace) {
                const consumer = consumers[address];
                if (consumer === undefined) {
                    mutableTraceLines.push(undefined);
                    continue;
                }
                const { source, line, column } = consumer.originalPositionFor({ line: lineNumber, column: 0 });
                if (source === null || line === null) {
                    mutableTraceLines.push(undefined);
                    continue;
                }
                const sourceContent = consumer.sourceContentFor(source, true);
                let sourceValue;
                if (sourceContent !== null && column !== null) {
                    const sourceLine = sourceContent.split('\n')[line - 1];
                    if (sourceLine !== undefined) {
                        sourceValue = utils_1.getChunk(sourceLine.slice(column));
                    }
                }
                if (sourceValue === undefined || sourceValue.trim() === '') {
                    sourceValue = 'unknown';
                }
                mutableTraceLines.push({
                    line,
                    file: onlyFileName ? path.basename(source) : source,
                    token: sourceValue,
                    column: column === null ? undefined : column,
                });
            }
            return mutableTraceLines;
        }
        const [currentAddress, currentSourceMap] = remainingSourceMaps[0];
        return source_map_1.SourceMapConsumer.with(currentSourceMap, undefined, async (consumer) => withSourceMaps(Object.assign(Object.assign({}, consumers), { [currentAddress]: consumer }), remainingSourceMaps.slice(1)));
    }
    return withSourceMaps({}, Object.entries(sourceMaps));
};

//# sourceMappingURL=processTrace.js.map
